export default "__VITE_ASSET__B5WM8DZ4__"